module.exports = __webpack_public_path__ + "static/media/Banner.66dd7275.gif";